import { Field } from "../FormField";

export const BankTab = ({ emp, set }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <Field label="Bank name" value={emp.bank_name} onChange={set("bank_name")} testId="detail-bank-name" />
    <Field label="Account number" value={emp.bank_account} onChange={set("bank_account")} testId="detail-bank-account" />
    <Field label="IFSC" value={emp.bank_ifsc} onChange={set("bank_ifsc")} testId="detail-ifsc" />
    <Field label="PAN" value={emp.pan} onChange={set("pan")} testId="detail-pan" />
    <Field label="UAN (PF)" value={emp.uan} onChange={set("uan")} testId="detail-uan" />
    <Field label="ESIC number" value={emp.esic_number} onChange={set("esic_number")} testId="detail-esic" />
  </div>
);
